export default "__VITE_ASSET__DAQx1MTs__";